import { AuthAuthPermissions } from '@robovision/rvai-auth'
import type { RvaiAbilityBuilder } from '../types'


export function defineSettingsAbility (
  builder: RvaiAbilityBuilder,
  permissions: AuthAuthPermissions[],
): void {
  const { can } = builder

  if (
    permissions.some((p) => [AuthAuthPermissions.SYSTEM_MANAGEMENT].includes(p))
  ) {
    can('crud', 'Settings')
    can('crud', 'Branding')
  }
}
